<template>
    <div>
        <v-layout>
            <v-flex xs12 sm6 offset-sm3 style="padding: 10px">
                <card class="z-depth-1">
                    <card-body>
                        <h4 class="card-title">optiWatt GmbH</h4>
                        <p class="card-text">
                            Geschäftsführender Gesellschafter:<br>
                            Dipl.-Ing. Hergen Thümler<br>
                            <br>
                            <br>
                            Postanschrift:<br>
                            Heinrich-Specht-Weg 26<br>
                            25421 Pinneberg<br>
                            Deutschland<br>
                            <br>
                            E-Mail: thuemler@optiwatt.de<br>
                            <br>
                            Telefon: 04101 606880<br>
                            <br>
                            Handelsregister: HRB 6867<br>
                            Amtsgericht Pinneberg<br>
                            <br>
                            USt-IdNr.: DE253651468<br>
                            <br>
                            Inhaltlich Verantwortlicher gemäß § 6 MDStV:<br>
                            Hergen Thümler<br>
                            letzte Aktualisierung: 18.12.2021<br>
                            <br>
                            Copyright: © 2007 optiWatt GmbH, Pinneberg. All rights are reserved.Das Werk ist einschließlich aller seiner Teile, sofern keine anderen Quellen angegeben wurden, urheberrechtlich geschützt. Jede Verwendung außerhalb der engen Grenzen des Urheberrechts sind unzulässig und strafbar. Das gilt vor allem für Vervielfältigungen in irgendeiner Form (Fotokopie, Mikrokopie, oder andere Verfahren), Übersetzungen oder die Einspeicherung und Verarbeitung in elektronische Systemen. die Einrichtung eines Hyperlinks von anderen Webseiten auf eine der Seiten ist ohne vorherige schriftliche Zustimmung von optiWatt untersagt.<br>
                            <br>
                            Haftungsausschluss: Die bereitgestellten Informationen auf dieser Website wurden sorgfältig geprüft und werden regelmäßig aktualisiert. Jedoch kann keine Haftung oder Garantie dafür übernommen werden, dass alle Angaben zu jeder Zeit vollständig, richtig und in letzter Aktualität dargestellt sind. Dies gilt insbesondere für alle Verbindungen ("Links") zu anderen Websites, auf die direkt oder indirekt verwiesen wird. Hinsichtlich der Links erklärt die optiWatt GmbH ausdrücklich, dass sie keinerlei Einfluss auf die Gestaltung und die Inhalte der verlinkten Seiten hat und sich diese Inhalte nicht zu eigen macht.
                        </p>
                    </card-body>
                </card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import card from '@/components/Card';
    import cardHeader from '@/components/CardHeader';
    import cardBody from '@/components/CardBody';
    export default {
        components:{
            'Card': card,
            'CardHeader': cardHeader,
            'CardBody': cardBody,
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/subpages/impressum.vue